import { useId } from 'react'
import { Link } from 'react-router-dom'
import { Explicacao } from '../../../components/Explicacao'
import { ROTULO_STATUS } from '../../../lib/glossario'
import type { Pagina, ResumoGmud } from '../../../types/gmud'
import { STATUS_FORA_DO_FLUXO } from './colunasDoQuadro'
import { QUADRO } from './textosDoQuadro'

/**
 * As recusadas, canceladas e revertidas — contadas, com link, e sem coluna.
 *
 * Elas não estão em etapa nenhuma do contrato (`etapaAtual` devolve nulo para as três), então uma
 * oitava coluna seria uma coluna que só cresce, ocupando em largura o espaço das etapas onde o
 * trabalho de fato está parado. Sumir com elas também não serve: uma solicitação recusada é
 * resultado, e quem procura por ela precisa saber que ela existe e onde está.
 *
 * A contagem sai da página carregada, e não de um total por estado — a API devolve uma página só
 * para os três. Quando ela vem truncada, a faixa diz quantas está mostrando de quantas, em vez de
 * exibir um número que parece exato.
 *
 * @param props a página dos estados terminais
 * @returns o rodapé, ou nada quando não há nenhuma
 */
export function RodapeForaDoFluxo({ pagina }: { pagina: Pagina<ResumoGmud> }) {
  const idDoTitulo = useId()
  if (pagina.totalElementos === 0) {
    return null
  }

  return (
    <section aria-labelledby={idDoTitulo} className="cartao px-4 py-3">
      <h2 id={idDoTitulo} className="flex items-center gap-1 text-sm font-semibold text-slate-900">
        {QUADRO.foraDoFluxo.titulo}
        <Explicacao titulo={QUADRO.foraDoFluxo.titulo} texto={QUADRO.foraDoFluxo.ajuda} />
      </h2>

      <ul className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-sm">
        {STATUS_FORA_DO_FLUXO.map((status) => (
          <li key={status}>
            <Link
              to={`/gmuds?status=${status}`}
              className="text-niteroi-700 underline underline-offset-2 hover:text-niteroi-800"
            >
              {ROTULO_STATUS[status] ?? status} ·{' '}
              {QUADRO.contagem(pagina.conteudo.filter((gmud) => gmud.status === status).length)}
              <span className="sr-only"> — {QUADRO.foraDoFluxo.ver}</span>
            </Link>
          </li>
        ))}
      </ul>

      {pagina.totalElementos > pagina.conteudo.length && (
        <p className="mt-2 text-xs text-slate-600">
          {QUADRO.truncado(pagina.conteudo.length, pagina.totalElementos)}
        </p>
      )}
    </section>
  )
}
